import { FC } from "react";
import {
  FieldValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import { InputLabel, TextField } from "@mui/material";
import { ButtonCancelA } from "../../common/components/ButtonCancelA";
import { SearchButton } from "../../common/components/SearchButton";

type CompanySearchProps = {
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues, FieldValues>;
  reset: UseFormReset<FieldValues>;
  setCompanySearch: any;
  setParentCompanySearch: (val: string) => void;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onAtomReset?: () => void;
};

export const OrganizationSearch: FC<CompanySearchProps> = ({
  register,
  handleSubmit,
  reset,
  setCompanySearch,
  setParentCompanySearch,
  setPage,
  onAtomReset,
}) => {

  const handleSubmitSearch = (data: any) => {
    setCompanySearch(data.companyName ?? "" );
    setParentCompanySearch(data.parentCompanyName ?? "");
    setPage(0);
  };

  const handleReset = () => {
    reset({ parentCompanyName: "", companyName: "" });
    setCompanySearch("");
    setParentCompanySearch("");
    setPage(0);
    onAtomReset?.();
  };

  return (
    <div className="mt-9 border-2 pt-7 pb-7">
      <form onSubmit={handleSubmit(handleSubmitSearch)}>
        <div className="flex flex-row justify-center items-center gap-8">
          <div className="flex flex-row items-center">
            <label className="font-bold mr-3 whitespace-nowrap">Company</label>
            <TextField
              {...register("parentCompanyName")}
              defaultValue={""}
              sx={{
                "& .MuiInputBase-input": {
                  height: "5px",
                },
              }}
            />
          </div>
          <div className="flex flex-row items-center">
            <label className="font-bold mr-3 whitespace-nowrap">Organization</label>
            <TextField
              {...register("companyName")}
              defaultValue={""}
              sx={{
                "& .MuiInputBase-input": {
                  height: "5px",
                },
              }}
            />
          </div>
        </div>

        <div className="flex flex-center justify-center mt-10 gap-5">
          <ButtonCancelA
            name="Reset"
            onHandleClick={handleReset}
            icon={<ClearIcon />}
          />
          <SearchButton />
        </div>
      </form>
    </div>
  );
};
